import { ChainId } from '@1inch-community/models';
export function isChainId(chainId) {
    return ChainId[chainId] !== undefined;
}
export function requireChainId(chainId) {
    if (!isChainId(chainId))
        throw new Error(`chain ${chainId} not supported`);
}
export function parseChainId(chainIdStr) {
    const chainId = parseInt(chainIdStr, 10);
    if (!isChainId(chainId)) {
        throw new Error(`chain ${chainId} not supported`);
    }
    return chainId;
}
//# sourceMappingURL=is-chain-id.js.map